module.exports = __webpack_public_path__ + "img/level2addon_idle.4e249b5b.png";